import React from 'react';
import './case-header.scss';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/config/store';
import { CaseState } from 'app/shared/reducers/case-entity';

export interface ICaseHeaderProps {
  caseHeaderData?: CaseState;
  headerTitle?: string;
}

const CasePreviewHeader = (props: ICaseHeaderProps) => {
  const selectedCase = props.caseHeaderData ? props.caseHeaderData : useSelector((state: IRootState) => state.caseEntity);

  return (
    <div id="case-header-wrapper">
      <Row>
        <Col xs={10}>
          <span className="case-header-column">
            <h3 className="fw-bold">{`${props.headerTitle}: ${selectedCase?.caseCategory}`}</h3>
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs={10}>
          <span className="case-header-column">
            <span className="case-header-label">Šifra:</span>
            <span className="case-header-text">{selectedCase?.webId}</span>
          </span>
          <span className="case-header-column">
            <span className="case-header-label">Status zahtjeva:</span>
            <span className="case-header-text">{selectedCase?.caseStatus}</span>
          </span>
        </Col>
      </Row>
      <hr className="mt-4 mb-4" style={{ height: '2px', backgroundColor: 'black' }} />
    </div>
  );
};

export default CasePreviewHeader;
